const windows = {
  onScroll: function () {
    let scrollDom = document.getElementById('apps')
    scrollDom.addEventListener('scroll', function () {
      let top = scrollDom.scrollTop
      let backTopBtn = document.getElementById('backTopBtn');
      let hotsbox = document.getElementById("hotsbox");
      let watchPage = document.getElementById("watchPage");
      let sideToolsBox = document.getElementById('sideToolsBox');
      let footer = document.getElementById('footerBox');
      let apps = document.getElementById('apps');
      if (top > 80) {
        Tools.addClass(document.getElementById('Header-container'), 'showBg')
        Tools.removeClass(backTopBtn, 'showBackTop')
      } else {
        Tools.removeClass(document.getElementById('Header-container'), 'showBg')
        Tools.addClass(backTopBtn, 'showBackTop')
      }
      if (watchPage && top > 100 && watchPage.clientHeight - top - 635 > 0) {
        Tools.addClass(hotsbox, 'fixedInPage')
      } else {
        Tools.removeClass(hotsbox, 'fixedInPage')
      }

      let isBottom = apps.scrollHeight - top - sideToolsBox.clientHeight - footer.clientHeight

      if (sideToolsBox && footer && apps && isBottom - footer.clientHeight < 0) {
        Tools.addClass(sideToolsBox, 'hideTools')
      } else {
        Tools.removeClass(sideToolsBox, 'hideTools')
      }
      // cb(top)

    })
  },
  backTop: function () {
    let scrollDom = document.getElementById('apps');
    let currentPosition, timer
    timer = setInterval(function () {
      currentPosition = scrollDom.scrollTop
      currentPosition -= 10
      if (currentPosition > 0) {
        // scrollDom.scrollTo(0, currentPosition)
        scrollDom.scrollTop = currentPosition
      } else {
        // scrollDom.scrollTo(0, 0)
        scrollDom.scrollTop = 0
        clearInterval(timer)
      }
    }, 1)
  }
}

const Videos = {
  recordType: function (path) {
    let reg1 = new RegExp('.vertical.mp4')
    let reg2 = new RegExp('.transverse.mp4')
    if (path.match(reg1)) {
      return true
    } else if (path.match(reg2)) {
      return false
    } else {
      console.warn('当前的名师视频格式不对')
    }
  }
}

const bannerImgs = {
  judgeType: function (path) {
    let reg1 = new RegExp('.dark.')
    let reg2 = new RegExp('.light.')
    if (path.match(reg1)) {
      return true
    } else if (path.match(reg2)) {
      return false
    } else {
      console.warn('当前的banner图格式不对')
    }
  }
}
const Tools = {
  addClass: function (Doms, classname) {
    if (Doms && Doms.classList.length > 0) {
      Doms.classList.add(classname)
    }
  },
  removeClass: function (Doms, classname) {
    if (Doms && Doms.classList.length > 0) {
      Doms.classList.remove(classname)
    }
  },
}

const Browser = {
  isWhich: function () {
    function myBrowser() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      if (userAgent.indexOf("Opera") > -1) {
        return "Opera"
      } // 判断是否Opera浏览器
      if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      } // 判断是否Firefox浏览器
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
      } // 判断是否Chrome浏览器
      if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
      } // 判断是否Safari浏览器
      if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1) {
        return "IE";
      } // 判断是否IE浏览器
    }
    //以下是调用上面的函数
    var nowBrowser = myBrowser();
    if ("IE" == nowBrowser) {
      console.log("IE")
      alert('为了您更好的浏览器体验建议您更换浏览器 以下是现阶段最流行的浏览器 chrome firefox safari')
    }
    if ("FF" == nowBrowser) {
      console.log("Firefox")
    }
    if ("Chrome" == nowBrowser) {
      console.log("Chrome")
    }
    if ("Opera" == nowBrowser) {
      console.log("Opera")
    }
    if ("Safari" == nowBrowser) {
      console.log("Safari")
    }
  }
}
export {
  windows,
  Videos,
  bannerImgs,
  Tools,
  Browser
}